import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { RootState } from '../store/store';

/**
 * Hook to get the current account context for API calls.
 *
 * Returns the selected account ID for admin users, or undefined for regular users
 * (which will use their own account from the JWT token).
 *
 * @returns {accountId: number | undefined} The account ID to use for API calls
 */
export const useAccountContext = () => {
  const selectedAccount = useSelector((state: RootState) => state.app.selectedAccount);
  const isAdmin = useSelector((state: RootState) => state.app.isAdmin);

  // For admin users, use selected account ID, otherwise use undefined (will use user's own account from JWT)
  const accountId = isAdmin ? selectedAccount?.accountId : undefined;

  return useMemo(() => ({
    accountId,
  }), [accountId]);
};
